module.exports = __webpack_public_path__ + "img/17.bd2a9036.png";